module.exports = __webpack_public_path__ + "img/upload-to-cloud.a0e1eb97.svg";